// Bundler alias target for `metabase/selectors/admin`. IAS deployments must not
// surface the top admin-nav entries whose routes are hidden — the biggest one
// today is "Embedding". Re-implementing the selector here (rather than wrapping
// the upstream one) avoids the alias cycle and keeps the shape identical.

import type { State } from "metabase/redux/store";

import { isBlockedAdminRoute } from "./route-blocklist";

export const getAdminPaths = (state: State) => {
  const paths = state.admin?.app?.paths ?? [];
  return paths.filter((item) => !isBlockedAdminRoute(item.path));
};
